(ns dre.components.inputs
  (:require
   ["antd" :refer [Checkbox Input InputNumber]]
   [dre.components.icon :refer [icon]]
   [dre.utils.bem :as bem]))

(def component-name :inputs)

(defn input-text
  [props]
  [:input
   (assoc props
          :class (bem/be :inputs :input))])

(defn input-textarea
  [props]
  [:textarea
   (assoc props 
          :class (bem/be :inputs :textarea))])

(defn input-search
  [props]
  [:span
   {:class (bem/be :inputs :search)}
   [:input
    (cond-> (assoc props
                   :type (or (:type props) :text)
                   :class [:search-input (when (:on-search props) (bem/bm :search-input :with-button))])
      true (dissoc :on-search)
      (:on-search props) (assoc :on-key-press #(when (= (.-key %) "Enter")
                                                 ((:on-search props) %))))]
   (when (:on-search props)
     [:span
      {:class :search-button
       :on-click (fn [e]
                   ((:on-search props) e))}
      [icon :common :search]])])

(defn input-number
  [props]
  [:> InputNumber
   props])

(defn checkbox
  [props content]
  [:> Checkbox
   props content])
